import React from 'react'
import dat from '../../Assets/dat.png'
import { ReactComponent as GDPRSvg } from '../../Assets/gdpr.svg';

function Compliance() {
  return (
    <div  className=" w-[90%] lg:w-[85%] 2xl:w-[78%] flex flex-col gap-10 mt-24 items-center mb-10">       
    <span className='bold text-[20px] sm:text-[24px] lg:text-[30px] text-center'>Enterprise-ready compliance</span>
    <span className=' text-sm sm:text-base lg:text-[17px] text-center w-full lg:w-[60%]'>Delivering exceptional customer experiences involves ensuring the utmost confidence in data protection. At Elyzian, security is not an afterthought but an integral part of our identity and product design..</span>
      
    <div className='min-h-[100px]  w-full flex justify-center gap-20'>
        <img src={dat} className='h-[140px] aspect-auto rounded-full'  alt="" />
        <GDPRSvg />
    </div>
  </div>
  )
}

export default Compliance
